var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',_vm._l((_vm.script),function(screen,index){return _c('li',{key:`dev-link-${index}`},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.setCurrentScreen(screen.id)}}},[_vm._v(_vm._s(screen.id))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }